import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'

import 'video.js/dist/video-js.css'
import i18n from './i18n';

import enhancedCacheManager from './common/enhancedCache';
import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
import '@vant/touch-emulator';

// ✅ 导入 axios
import axios from 'axios';

Vue.use(VueDPlayer);
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.prototype.$cache = enhancedCacheManager
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(Vant);

// ✅ 语言映射配置
// const languageMap = {
//   'ko': 'ko-KR',
//   'zh-CN': 'zh-CN', 
//   'en': 'en-US',
//   'jp': 'ja-JP',
//   'tu': 'tu-TU'  
// }

const languageMap = {
  // 'ko': 'ko-KR',
  // 'zh-CN': 'zh-CN', 
  'en': 'en-US',
  // 'jp': 'ja-JP',
  'tu': 'tu-TU'  
}

// ✅ 获取当前语言并设置语言头
const currentLanguage = localStorage.getItem('change-language') || 'tu-TU';
const backendLanguage = languageMap[currentLanguage] || 'tu-TU';

// ✅ 设置 axios 默认语言头
axios.defaults.headers.common['Accept-Language'] = backendLanguage;

// ✅ 添加请求拦截器确保每个请求都有语言头
axios.interceptors.request.use(config => {
  const lang = localStorage.getItem('change-language') || 'tu-TU';
  const backendLang = languageMap[lang] || 'tu-TU';
  config.headers['Accept-Language'] = backendLang;
  return config;
});

// 简单的路由守卫，确保注销后跳转到登录页
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  const whiteList = ['/Home', '/', '/Login', '/Register']
  
  if (!token && !whiteList.includes(to.path)) {
    next('/Login')
    return
  }
  
  if (token && to.path === '/Login') {
    next('/Home')
    return
  }
  
  next()
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')